import { ISegmentConfigData } from './type';

export const dehydrateFormData = (data: ISegmentConfigData): ISegmentConfigData => {
	const conversionConfig: ISegmentConfigData = {} as ISegmentConfigData;
	conversionConfig.liveSegmentList = data.liveSegmentList;
	conversionConfig.userSegmentList = data.userSegmentList;
	conversionConfig.customAbsorptionAmount = data.customAbsorptionAmount;
	conversionConfig.firstWithdrawalAbsorptionEnabled = data.firstWithdrawalAbsorptionEnabled;
	conversionConfig.isEnabled = data.isEnabled;
	conversionConfig.isLiveSegmentEnabled = data.isLiveSegmentEnabled;
	return conversionConfig;
};
